'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$() {
  this.aQd = null;
  this.aQe = false;
  this.aQf = null;
  this.aQg = false;
  this.aQ9 = null;
  this.aQa = false;
  this.aQb = null;
  this.aQc = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$.prototype = $p;
$p.aA = (function() {
  if ((!this.aQe)) {
    this.aQd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$1(this);
    this.aQe = true;
  }
  return this.aQd;
});
$p.o3 = (function() {
  if ((!this.aQg)) {
    this.aQf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aQg = true;
  }
  return this.aQf;
});
$p.J2 = (function(x$0) {
});
$p.jh = (function() {
  if ((!this.aQa)) {
    this.aQ9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy4 = $x_1.iu(this$1.pp(1, this$1.hX));
      if ((e$proxy4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy4.bj) + ")"));
      }
      if ((e$proxy4 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy4.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy4);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aQa = true;
  }
  return this.aQ9;
});
$p.AN = (function() {
  if ((!this.aQc)) {
    this.aQb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Quantity";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aQc = true;
  }
  return this.aQb;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$, "app.data.data_point_types$package$Quantity$", ({
  Go: 1,
  B: 1,
  C: 1,
  cz: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Quantity$ };
//# sourceMappingURL=app.data.data_point_types$package$-Quantity$.js.map
